import React from 'react';
import './index.scss';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from 'react-accessible-accordion';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

const FaqsAccordian = () => {
  const { t, i18n } = useTranslation();
  const faqsList = [
    {
      Question: t('Frequently Asked Ques 1'),
      Answer: t('Frequently Asked Ques 1 ans')
    },
    {
      Question: t('Frequently Asked Ques 2'),
      Answer: t('Frequently Asked Ques 2 ans')
    },
    {
      Question: t('Frequently Asked Ques 3'),
      Answer: t('Frequently Asked Ques 3 ans')
    },
    {
      Question: t('Frequently Asked Ques 4'),
      Answer: t('Frequently Asked Ques 4 ans')
    },
    {
      Question: t('Frequently Asked Ques 5'),
      Answer: t('Frequently Asked Ques 5 ans')
    },
    {
      Question: t('Frequently Asked Ques 6'),
      Answer: t('Frequently Asked Ques 6 ans')
    },
    {
      Question: t('Frequently Asked Ques 7'),
      Answer: t('Frequently Asked Ques 7 ans')
    },
    {
      Question: t('Frequently Asked Ques 8'),
      Answer: t('Frequently Asked Ques 8 ans')
    },
    {
      Question: t('Frequently Asked Ques 9'),
      Answer: t('Frequently Asked Ques 9 ans')
    },
    {
      Question: t('Frequently Asked Ques 10'),
      Answer: [
        { para: t('Frequently Asked Ques 10 ans para 1') },
        { para: t('Frequently Asked Ques 10 ans para 2') },
        { para: t('Frequently Asked Ques 10 ans para 3') },
        { para: t('Frequently Asked Ques 10 ans para 4') },
        { para: t('Frequently Asked Ques 10 ans para 5') },
        { para: t('Frequently Asked Ques 10 ans para 6') },
        { para: t('Frequently Asked Ques 10 ans para 7') }
      ]
    }
  ];
  return (
    <section className="faqMainContainer">
      <div className="innerContainer">
        <h2>{t('Frequently Asked Ques')}</h2>
        <Accordion allowZeroExpanded="true">
          {faqsList.map((item, index) => {
            return index === 9 ? (
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>{item.Question}</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  {item.Answer.map((subItem, index) => {
                    return (
                      <p key={index} className="marginBottom-10">
                        {subItem.para}
                      </p>
                    );
                  })}
                  <p>
                    {t('See text')}&nbsp;
                    <a
                      href={_.withLocale(
                        i18n.language,
                        '/terms-and-conditions'
                      )}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t('Terms & Conditions')}
                    </a>
                    &nbsp;{t('For additional details')}
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
            ) : (
              <AccordionItem key={index}>
                <AccordionItemHeading>
                  <AccordionItemButton>{item.Question}</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>{item.Answer}</p>
                </AccordionItemPanel>
              </AccordionItem>
            );
          })}
        </Accordion>
        <div className="contInfo">
          {t('Still have questions? Call')}{' '}
          <a href="tel:844-234-3057">844-234-3057</a>
        </div>
      </div>
    </section>
  );
};
export default FaqsAccordian;
